


















































































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { ShipmentDTO } from "@/model/data.model";
import { DocumentListItem } from "@/model/component.model";
import { ShipmentService } from "@/services/ShipmentService";
import { translateErrorMessage } from "@/services/Helpers";

@Component({})
export default class AttachmentsModal extends Vue {
  @Prop() shipmentId: string;
  @Prop() shipmentDocuments: any;
  @Prop() loadedDocs: any;
  @Prop({
    default: false
  })
  fromNewShip: boolean;

  shipment: ShipmentDTO | null = null;
  documents: DocumentListItem[] = [];
  allDocumentsSelected = false;

  files: any[] = [];

  created() {
    this.loadAttachments();
  }

  loadAttachments() {
    if (!this.fromNewShip) {
      ShipmentService.getShipment(this.shipmentId).then(shipment => {
        this.shipment = shipment;
        this.documents = [];
        this.getAttahmentsFromId(this.shipmentId);
      });
    } else if (this.shipmentId) {
      this.documents = [];
      this.getAttahmentsFromId(this.shipmentId);
    } else if (this.loadedDocs && this.loadedDocs.length > 0) {
      this.documents = this.loadedDocs;
    }
  }
  getAttahmentsFromId(id: string) {
    ShipmentService.getAttachmentsSignedURLs(id).then(urls => {
      urls.forEach((url: string) => {
        const filename = /\/([^\/]+)\?/.exec(url);
        if (filename !== null && filename.length > 1) {
          this.documents.push({
            url: url,
            filename: filename[1],
            selected: false
          } as DocumentListItem);
        }
      });
    });
  }
  selectItem(item: DocumentListItem) {
    item.selected = !item.selected;
  }

  selectAll(value: boolean) {
    this.allDocumentsSelected = value;
    this.documents.forEach((document: DocumentListItem) => {
      document.selected = value;
    });
  }

  documentsSelected(): DocumentListItem[] {
    return this.documents.filter(
      (document: DocumentListItem) => document.selected
    );
  }

  showFileDialog() {
    const inputFile = this.$refs.fileInput as HTMLInputElement;
    if (inputFile) inputFile.click();
  }

  filesAdded(e: any) {
    if (!this.fromNewShip || this.shipmentId) {
      ShipmentService.uploadAttachments(this.shipmentId, e.srcElement.files)
        .then(() => {
          this.loadAttachments();
          if (this.fromNewShip) {
            this.$notify.success(this.$t("attachments_uploaded").toString());
          }
        })
        .catch(reason => {
          this.$alerts
            .danger(translateErrorMessage(reason))
            .then(() => this.loadAttachments());
        });
    } else {
      this.documents.push({
        url: e.srcElement.files[0].webkitRelativePath,
        filename: e.srcElement.files[0].name,
        files: e.srcElement.files,
        selected: false
      } as any);
    }
  }
  deleteAttachmentsShip(index: number) {
    if (this.shipmentId && this.shipmentDocuments) {
      const documentsToDelete = this.shipmentDocuments.filter(
        shipmentDocument => {
          return [this.documents[index]].some(doc => {
            return this.decodeURIAndPar(doc.url).includes(
              this.getFilename(shipmentDocument.pathDocument)
            );
          });
        }
      );

      ShipmentService.deleteAttachments(this.shipmentId, documentsToDelete)
        .then(() => {
          this.loadAttachments();
          this.$notify.success(this.$t("attachments_deleted").toString());
        })
        .catch(reason => {
          this.$alerts
            .danger(translateErrorMessage(reason))
            .then(() => this.loadAttachments());
        });
    } else {
      this.documents.splice(index, 1);
    }
  }

  deleteAttachments() {
    if (this.shipment) {
      const documentsToDelete = this.shipment.documents.filter(
        shipmentDocument => {
          return this.documentsSelected().some(doc => {
            return this.decodeURIAndPar(doc.url).includes(
              this.getFilename(shipmentDocument.pathDocument)
            );
          });
        }
      );

      ShipmentService.deleteAttachments(this.shipmentId, documentsToDelete)
        .then(() => this.loadAttachments())
        .catch(reason => {
          this.$alerts
            .danger(translateErrorMessage(reason))
            .then(() => this.loadAttachments());
        });
    }
  }
  @Watch("documents", { deep: true })
  confirmAttachments() {
    this.$emit("confirmAttachments", this.documents);
  }

  getFilename(data: string) {
    return data.substr(data.lastIndexOf("/") + 1);
  }
  decodeURIAndPar(data: string) {
    return decodeURIComponent(data);
  }
}
